import type { ComputedRef, InjectionKey } from 'vue'

import type { KStepTitleAs } from './types'

export interface KStepsContext {
    /** Steps render as disclosures rather than static list items. */
    collapsible: ComputedRef<boolean>
    /** Heading level for every step title in the list. */
    titleAs: ComputedRef<KStepTitleAs>
    /** The element a step renders as, derived from the list element. */
    itemAs: ComputedRef<'li' | 'div'>
}

export const K_STEPS_CONTEXT = Symbol('KSteps') as InjectionKey<KStepsContext>
